import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { UserManagementService } from 'src/app/Service/user-management.service';

@Component({
  selector: 'app-access-control',
  templateUrl: './access-control.component.html',
  styleUrls: ['./access-control.component.scss'],
})
export class AccessControlComponent implements OnInit {
  toDisplay = true;
  response;
  title = 'Select/ Unselect All Checkboxes';
  masterSelected: boolean;
  checklist: any;
  menuList: any;
  unchecked;
  form: FormGroup;
  reg: string | RegExp;
  sort: any;

  userlist;
  isSelectAll: boolean = false;
  userlistdata = [];
  dataSource;
  paginator;

  checkedList;
  getMenuDataFromAPI: any = [];
  dialogRef: any;
  accessDataList;
  userId;
  newMenuList;
  MenuList1: any = [];
  MenuList: Array<any> = [
    { id: 1, viewValue: 'Users', value: 'Users', isSelected: false },
    {
      id: 2,
      viewValue: 'Market Rate Updates',
      value: 'Market Rate Updates',
      isSelected: false,
    },
    { id: 3, viewValue: 'Product', value: 'Product', isSelected: false },
    {
      id: 4,
      viewValue: 'Transaction',
      value: 'Transaction',
      isSelected: false,
    },
    {
      id: 5,
      viewValue: 'Ask An Expert',
      value: 'AskAnExpert',
      isSelected: false,
    },
    {
      id: 6,
      viewValue: 'Document Verification',
      value: 'Document Verification',
      isSelected: false,
    },
    { id: 7, viewValue: 'News', value: 'News', isSelected: false },
    { id: 8, viewValue: 'Blogs', value: 'Blogs', isSelected: false },
    {
      id: 9,
      viewValue: 'Govt Schemes',
      value: 'GovtSchemes',
      isSelected: false,
    },
    { id: 10, viewValue: 'Reminders', value: 'Reminders', isSelected: false },
    {
      id: 11,
      viewValue: 'Track Your Harvest',
      value: 'TrackYourHarvest',
      isSelected: false,
    },
    { id: 12, viewValue: 'Survey', value: 'Survey', isSelected: false },
    {
      id: 13,
      viewValue: 'In App Review',
      value: 'In App Review',
      isSelected: false,
    },
    {
      id: 14,
      viewValue: 'Banner Management',
      value: 'Banner Management',
      isSelected: false,
    },
    {
      id: 15,
      viewValue: 'Video Library',
      value: 'Video Library',
      isSelected: false,
    },
    // { id: 14, viewValue: 'Setting', value: 'Setting', isSelected: false },
  ];

  selectedUser: any;
  constructor(
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private router: Router,
    public toastr: ToastrService,
    private dialog: MatDialog,
    private matDialog: MatDialog,
    public _userService: UserManagementService
  ) {}

  accessData;
  ngOnInit(): void {
    setTimeout(() => {
      this.spinner.hide();
    }, 4000);

    this._userService.getAdminUser().subscribe((data) => {
      // this.accessData = data
      this.accessDataList = data['result']['data'];
    });
  }
  getMenuAccessControl(e: any) {
    this.userId = e.value;
    var postdata = {
      userId: e.value,
    };
    this.spinner.show();
    this._userService.getMenuAccess(postdata).subscribe((data) => {
      if (data['result'].data == null) {
        console.log("data['result']", data['result']);
        const MenuListStringify = JSON.stringify(this.MenuList);
        this.MenuList1 = JSON.parse(MenuListStringify);
        this.spinner.hide();
      } else {
        this.getMenuDataFromAPI = data['result'].data.menus.split(',');
        const MenuListStringify = JSON.stringify(this.MenuList);
        this.MenuList1 = JSON.parse(MenuListStringify);

        this.getMenuDataFromAPI.map((resp) => {
          this.MenuList1.map((innerResp) => {
            if (innerResp.viewValue == resp) {
              innerResp.isSelected = true;
            }
          });
        });
        this.spinner.hide();
        //  this.toDisplay = !this.toDisplay;
      }
    });
  }
  onSubmit() {
    const checkedValueName = JSON.parse(this.checkedList).map((resp) => {
      return resp.viewValue;
    });
    const finalMenuName = checkedValueName.join(',');
    var postdata = {
      userId: this.userId,
      menus: finalMenuName,
    };

    this._userService.postMenuAccess(postdata).subscribe((data) => {
      if (data['result'].data) {
        this.toastr.success(data['result'].message, 'Success', {
          timeOut: 3000,
        });
      } else {
        this.toastr.error(data['result'].message, 'Error', {
          timeOut: 3000,
        });
      }
      // this.spinner.show();
      // window.location.reload();
    });
  }
  checkUncheckAll(event) {
    // if(event.checked){
    for (var i = 0; i < this.MenuList1.length; i++) {
      this.MenuList1[i].isSelected = this.masterSelected;
      this.checkedList = JSON.stringify(this.checkedList);
    }
    this.getCheckedItemList();
    //  }
    //   else{

    //  }
  }

  // Check All Checkbox Checked
  isAllSelected() {
    this.masterSelected = this.MenuList1.every((item: any) => {
      return item.isSelected == true;
    });
    this.getCheckedItemList();
  }
  // Get List of Checked Items
  getCheckedItemList() {
    this.checkedList = [];
    for (var i = 0; i < this.MenuList1.length; i++) {
      if (this.MenuList1[i].isSelected)
        this.checkedList.push(this.MenuList1[i]);
    }
    this.checkedList = JSON.stringify(this.checkedList);
  }
  closeDialog() {
    const MenuListStringify = JSON.stringify(this.MenuList);
    this.MenuList1 = JSON.parse(MenuListStringify);

    this.getMenuDataFromAPI.map((resp) => {
      this.MenuList1.map((innerResp) => {
        if (innerResp.viewValue == resp) {
          innerResp.isSelected = true;
        }
      });
    });
    this.masterSelected = false;
  }
}
